import { useLocation } from "react-router";
import { useCallback, useEffect } from "react";
import { useScrollStore } from "@/common/store/scrollStore";

export const useScroll = () => {
  const scrolls = useScrollStore((state) => state.scrolls);
  const setScroll = useScrollStore((state) => state.setScroll);
  const scrollElement = useScrollStore((state) => state.scrollElement);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    if (!scrollElement) {
      return;
    }

    setScroll(location.key, scrollElement.scrollTop);
  }, [scrollElement, location]);

  useEffect(() => {
    setTimeout(() => {
      const scrollY = scrolls[location.key] ?? 0;
      scrollElement?.scrollTo(0, scrollY);
    }, 0);
  }, [location]);

  useEffect(() => {
    scrollElement?.addEventListener("scroll", handleScroll);

    return () => {
      scrollElement?.removeEventListener("scroll", handleScroll);
    };
  }, [scrollElement, handleScroll]);
};
